const DEFAULT_TIMEOUT = 5;
const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "50px 0px",
  threshold: 0
};

function binder(methods, object) {
  methods.forEach(function (method) {
    object[method] = object[method].bind(object);
  });
}

function Store(target) {
  const self = this;

  self.figure = target.querySelector("figure");
  self.labels = target.querySelectorAll("label[rel]");
  self.radios = [].slice.call(target.querySelectorAll("[type=radio]"));
}

function Autoplay(target) {
  const self = this;

  self.target = target;
  self.timeout = (parseInt(target.dataset.autoplay, 10) || DEFAULT_TIMEOUT) * 1e3;
  binder(["scroll", "toggle"], self);

  target.addEventListener("mouseout", self.start);
  target.addEventListener("mouseover", self.stop);
}

Object.assign(Autoplay.prototype, {
  scroll: function scroll() {
    const { radios } = this.target.store;
    const current = radios.findIndex(radio => radio.checked);
    const next = current === radios.length - 1 ? 0 : current + 1;

    radios[next].checked = true;
    radios[next].dispatchEvent(new Event("change", { bubbles: true }));
  },
  start: function start(e) {
    const { autoplay: self } = e.target.closest("section");

    self.interval = window.setInterval(self.scroll, self.timeout);
  },
  stop: function stop(e) {
    const { autoplay: self } = e.target.closest("section");

    window.clearInterval(self.interval);
    delete self.interval;
  },
  toggle: function toggle() {
    const event = document.visibilityState === "hidden" ? "mouseover" : "mouseout";

    this.target.dispatchEvent(new Event(event));
  }
});

function Navigation(target) {
  const self = this;

  self.target = target;
  binder(["navigate", "setHtmlFor", "setLabels"], self);

  self.setLabels(target.store.radios.findIndex(radio => radio.checked));
  target.addEventListener("change", self.navigate);
}

Object.assign(Navigation.prototype, {
  navigate: function navigate(e) {
    const { setLabels, target } = this;
    const { figure } = target.store;
    const index = parseInt(e.target.id.split("-").pop(), 10);
    const marginLeft = index === 0 ? "" : `${index * -100}%`;

    setLabels(index);
    figure.style.marginLeft = marginLeft;
  },
  setHtmlFor: function setHtmlFor(selectedIndex) {
    const { labels, radios } = this.target.store;

    if (labels.length) {
      const nextIndex = selectedIndex === radios.length - 1 ? 0 : selectedIndex + 1;
      const prevIndex = selectedIndex === 0 ? radios.length - 1 : selectedIndex - 1;

      labels[0].htmlFor = radios[prevIndex].id;
      labels[1].htmlFor = radios[nextIndex].id;
    }
  },
  setLabels: function setLabels(selectedIndex) {
    const { setHtmlFor, target } = this;
    const { labels } = target.store;

    if (labels.length) {
      setHtmlFor(selectedIndex);
    }
  }
});

function addArrows(fragment) {
  ["left", "right"].forEach(function (direction) {
    const label = document.createElement("label");

    label.className = `far fa-chevron-${direction}`;
    label.setAttribute("rel", direction === "left" ? "prev" : "next");
    label.title = `${direction === "left" ? "Previous" : "Next"} image`;

    fragment.appendChild(label);
  });
}

function addInput({ counter, fragment, index, target }) {
  const input = document.createElement("input");
  const id = `carousel-${counter}-radio-${index}`;

  if (index === 0) {
    input.setAttribute("checked", "");
  }

  input.setAttribute("hidden", "");

  input.id = id;
  input.name = `carousel-${counter}-radio`;
  input.type = "radio";

  fragment.appendChild(input);
  if (target.hasAttribute("data-blobs")) {
    const label = document.createElement("label");

    label.htmlFor = id;
    label.title = `Show image ${index + 1}`;

    fragment.appendChild(label);
  }
}

function addAside(target) {
  const { counter } = target.dataset;
  const { length } = target.querySelectorAll("figure");

  if (length < 2) {
    return;
  }

  const fragment = document.createDocumentFragment();

  for (let index = 0; index < length; index += 1) {
    addInput({ counter, fragment, index, target });
  }

  if (target.hasAttribute("data-arrows")) {
    addArrows(fragment);
  }

  const aside = document.createElement("aside");

  aside.setAttribute("aria-hidden", "true");
  aside.appendChild(fragment);

  target.insertBefore(aside, target.firstChild);
}

function processAutoplay(target) {
  if (target.hasAttribute("data-autoplay")) {
    target.autoplay = new Autoplay(target);

    if (document.visibilityState !== "hidden") { // start autoplay if document visible
      target.autoplay.start({ target });
    }

    document.addEventListener("visibilitychange", target.navigation.toggle);
  }
}

function processNavigation(target) {
  const label = target.querySelector("label");

  if (label) {
    target.navigation = target.navigation || new Navigation(target);
  }
}

function process(target) {
  addAside(target);
  target.store = new Store(target);

  processNavigation(target);
  processAutoplay(target);

  delete target.dataset.counter;
  target.classList.add("enhanced");
}

function onIntersection(entries, observer) {
  const intersection = entries.find(entry => entry.isIntersecting);

  if (intersection) {
    const { target } = intersection;

    process(target);
    observer.unobserve(target);
  }
}

function carouselise() {
  const carousels = document.querySelectorAll("[data-component=carousel-box]");

  if (carousels.length) {
    const intersectionObserver = new IntersectionObserver(onIntersection, OBSERVER_OPTIONS);

    carousels.forEach(function (carousel, index) {
      carousel.dataset.counter = index + 1;
      intersectionObserver.observe(carousel);
    });
  }
}

export default carouselise;



// WEBPACK FOOTER //
// ./scripts/sections/image-carousel.js